import "./Footer.css";

const Footer:React.FC = () => {
  
  return (
    <div className="styleFooter">
      <p>Created By @Artem Kot</p>
    </div>
  );
};


export default Footer;